// import logo from "./logo.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import React, { useEffect } from "react";
import {
  Routes,
  BrowserRouter,
  Route,
  useLocation,
  Navigate,
} from "react-router";
import Login from "./Pages/Login/Login";
import Booking from "./Pages/Booking/Booking";
import Startsession from "./Pages/Startsession/Startsession";
import Pastbooking from "./Pages/Pastbooking/Pastbooking";
import Appointmentdetail from "./Pages/Appointmentdetail/Appointmentdetail";
import Endsession from "./Pages/Endsession/Endsession";
import Updatepassword from "./Pages/Updatepassword/Updatepassword";
import { ToastContainer } from "react-toastify";
import Privateroute from "./Component/Privateroute/Privateroute";
import Completedsession from "./Pages/Completedsession/Completedsession";
import Upcomingbooking from "./Pages/Upcomingbooking/Upcomingbooking";
import { connect } from "react-redux";
import Hospitalroute from "./Component/Privateroute/hospitalroute";

function App(props) {
  const token = window.localStorage.getItem("token");
  const isLoggedIn = !!token;
  const { userdata } = props;
  const isHospitalProvider = userdata?.role === "hospital_provider";

  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      setTimeout(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      }, 0);
    }, [pathname]);

    return null;
  }
  return (
    <React.StrictMode>
      <BrowserRouter>
        <ScrollToTop />
        <ToastContainer />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/updatepassword" element={<Updatepassword />} />

          {/* Protected routes */}
          <Route element={<Privateroute />}>
            {/* {!isHospitalProvider && ( */}
            <>
              <Route path="/dashboard" element={<Booking />} />
              <Route path="/startsession" element={<Startsession />} />
              <Route path="/completesession" element={<Completedsession />} />
              <Route path="/pastbooking" element={<Pastbooking />} />
              <Route path="/upcomingbooking" element={<Upcomingbooking />} />
              <Route
                path="/appointmentdetail/:id"
                element={<Appointmentdetail />}
              />
              <Route path="/endsession" element={<Endsession />} />
            </>
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </React.StrictMode>
  );
}

const mapDispatchToProps = {};
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);
